import {useParams} from "react-router-dom";
import {GroupsService} from "../../../serverService/groups/GroupsService";
import {useAuthState} from "../../../context/AuthContext";
import {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    showErrorMessage,
    RaikoMultiSelectTable, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function GroupManagerDetail(
    {groupManager = []}
) {

    const {id: groupId} = useParams()
    let page = 0
    const size = 10


    const service = new GroupsService()
    const {fundID} = useAuthState()

    const [users, setUsers] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);

    const [selectedItems, setSelectedItems] = useState(groupManager);

    const [loadingState, setLoadingState] = useState(false);


    useEffect(() => {
        setSelectedItems(groupManager)
    }, [groupManager]);

    useEffect(() => {
        if (groupId && groupId > 0)
            getGroupUsers()
    }, [groupId]);

    function getGroupUsers() {
        setTableLoadingState(true)
        service.getGroupUsers(
            fundID,
            groupId,
            page,
            size
        ).then(response => {
            setUsers([])
            response.data.map((item, index) => {
                setUsers(prevState => [
                    ...prevState,
                    prepareTableItems(
                        (size * page) + index + 1,
                        item.id,
                        `${item.firstName} ${item.lastName}`,
                        item.nationalCode,
                        item.phoneNumber
                    )
                ])
            })

            setPageCount(response.totalPage)
            setTotalItems(response.numberOfItems)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoadingState(false)
        })
    }

    function prepareTableItems(number, id, fullName, nationalCode, phoneNumber) {
        return {
            id,
            name: fullName,

            number,
            fullName,
            nationalCode
        }
    }

    function handleChangePagination(newPage) {
        page = newPage
        getGroupUsers()
    }

    const [updateManagerLoadingState, setUpdateManagerLoadingState] = useState(false)

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"مدیر گروه"}
                    subTitle={"مدیر گروه را از بین اعضا گروه انتخاب نمایید."}
                    hasActionButton
                    actionButtonLoadingState={updateManagerLoadingState}
                    actionButtonTitle={"بروزرسانی"}
                    actionButtonOnclick={() => {
                        if (selectedItems[0]) {
                            setUpdateManagerLoadingState(true)
                            service.updateGroupLeader(
                                fundID,
                                groupId,
                                selectedItems[0].id
                            ).then(() => {
                                showSuccessMessage("مدیر گروه با موفقیت بروزرسانی شد")
                            }).catch(reason => {
                                showErrorMessage(detectServerErrorMessage(reason))
                            }).finally(_ => {
                                setUpdateManagerLoadingState(false)
                            })
                        } else {
                            showWarningMessage("لطفا یک مدیر برای گروه انتخاب کنید")
                        }
                    }
                    }
                >
                    <RaikoMultiSelectTable
                        pageCount={pageCount}
                        handleChangePagination={handleChangePagination}
                        tableData={users}
                        tableHeader={header}
                        setSelectedItems={setSelectedItems}
                        selectedItems={selectedItems}
                        isSingleSelect
                        notSelectedAnyItemAlertTitle={"هنوز هیچ مدیری برای این گروه انتخاب نشده است"}
                        notSelectedAnyItemAlertDescription={[]}
                        tableLoadingState={tableLoadingState}
                        tableHintTitle={""}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}

const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "fullName",
        label: "نام و نام خانوادگی"
    }, {
        id: "nationalCode",
        label: "کد ملی"
    },
]
